const theme = {
  // named colors:
  brand: '#41B883',
  accent: '#0a5eb7',
  accentDark: '#35495E',
  lightGrey: '#F6F6F6',
  darkGrey: '#91a2a3',
  ink: 'black',
  errorRed: '#FF6666',
  codeEditBlue: '#2973b7',
  codeEditGreen: '#42b983',

  // content width:
  contentWidthLaptop: '850px',
  sitePadding: '25px'
}

export default theme



// WEBPACK FOOTER //
// ./src/layouts/theme.js